export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";